<template>
  <footer :class="`footer-${$route.name}`">
    <div class="container">
      <div class="footer-in">
        <div class="footer-top">
          <ul class="d-flex flex-wrap">
            <li class="col-12 col-sm-6 col-md-4 col-lg-3">
              <div class="footer-cnt">
                <h3>Information</h3>
                <ul>
                  <li>
                    <router-link :to="{ name: 'privacyPolicy' }">Privacy Policy</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'termsConditions' }">Terms &amp; Conditions</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'whoWeAre' }">Who We Are</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'contactUs' }">Contact Us</router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-lg-6">
              <div class="footer-cnt">
                <h3>Our Partners</h3>
                <ul>
                  <li>
                    <a href="https://www.truelife.org">TrueLife.org</a>
                  </li>
                  <li>
                    <a href="https://www.aacc.net">American Association of Christian Counselors</a>
                  </li>
                  <li>
                    <a href="https://www.josh.org">Josh McDowell Foundation</a>
                  </li>
                </ul>
              </div>
            </li>
            <li class="col-12 col-sm-6 col-md-4 col-lg-3">
              <div class="footer-cnt">
                <h3>Connect</h3>
                <ul>
                  <li>
                    <a href="mailto:info@truelifecare.org" class="mail">info@truelifecare.org</a>
                  </li>
                  <li>
                    <a href="tel:8007490570" class="tel">(800) 749-0570</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <div class="footer-btm">
          <p>Copyright 2020 TrueLifeCare.org. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>
<style lang="scss">
/*---footer start--*/
footer {
  background: #363636;
  padding: 85px 0 0 0;
}
.footer-login {
  position: relative;
}
.footer-login:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 100%;
  height: 300px;
  bottom: 100%;
  background: #363636;
  z-index: 1;
}
.footer-top {
  padding: 0 0 11px 0;
  border-bottom: 1px solid #fff;
}
.footer-top > ul {
}
.footer-top > ul > li {
  padding: 0 0 10px 0;
}
.footer-cnt h3 {
  color: #ffffff;
  font-size: 28px;
  line-height: 30px;
  font-family: 'AvalonBold', Arial;
  letter-spacing: -0.2px;
  padding: 0 0 21px 0;
}
.footer-cnt > ul {
}
.footer-cnt > ul > li {
  display: flex;
  padding: 0 0 15px 0;
}
.footer-cnt > ul > li > a {
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  background: url(/images/footer-arw.png) no-repeat top left;
  padding: 0 0 0 28px;
  vertical-align: middle;
}
.footer-top > ul > li:nth-child(2) {
  padding: 0 0 10px 69px;
}
.footer-top > ul > li:nth-child(3) {
  padding: 0 0 10px 37px;
}
.footer-cnt > ul > li > a.mail {
  position: relative !important;
  padding: 10px 0 0 55px;
}
.footer-cnt > ul > li > a.mail {
  content: '';
  position: absolute;
  top: -2px;
  left: 0;
  background: url(/images/footer-mail.png) no-repeat;
  width: 100%;
  height: 43px;
}
.footer-cnt > ul > li > a.tel {
  position: relative !important;
  padding: 13px 0 0 57px;
}
.footer-cnt > ul > li > a.tel {
  content: '';
  position: absolute;
  top: -2px;
  left: 0;
  background: url(/images/footer-call.png) no-repeat top left;
  width: 100%;
  height: 43px;
}
.footer-btm {
  padding: 39px 0 22px 0;
}
.footer-btm p {
  text-align: center;
  font-size: 18px;
  line-height: 20px;
  color: #ffffff;
}
/*---footer end--*/
</style>
